import {
  FiHome,
  FiEdit3,
  FiBriefcase,
  FiCompass,
  FiHeart,
  FiFolder,
  FiUsers,
  FiUser,
  FiKey,
} from "react-icons/fi";

const createItem = (item) => ({
  ...item,
  activePrefixes: item.activePrefixes ?? [item.to],
});

export const CUSTOMER_PANEL_HOME = "/customer/myspace";

export const customerSidebarSections = [
  {
    id: "overview",
    title: "Overview",
    items: [
      {
        to: "/customer/myspace",
        label: "Dashboard",
        icon: FiHome,
        activePrefixes: ["/customer/myspace", "/customer/dashboard"],
      },
    ],
  },
  {
    id: "shared",
    title: "Shared",
    items: [
      {
        to: "/customer/posts",
        label: "Shared Posts",
        icon: FiEdit3,
        activePrefixes: ["/customer/posts"],
      },
      {
        to: "/customer/properties",
        label: "Shared Properties",
        icon: FiBriefcase,
        activePrefixes: ["/customer/properties"],
      },
      {
        to: "/customer/shared-leads",
        label: "Shared Leads",
        icon: FiCompass,
        activePrefixes: ["/customer/shared-leads"],
      },
    ],
  },
  {
    id: "myspace",
    title: "My Space",
    items: [
      {
        to: "/customer/my-properties",
        label: "My Properties",
        icon: FiBriefcase,
        activePrefixes: ["/customer/my-properties"],
      },
      {
        to: "/customer/my-posts",
        label: "My Posts",
        icon: FiEdit3,
        activePrefixes: ["/customer/my-posts"],
      },
      {
        to: "/customer/leases",
        label: "Lease Management",
        icon: FiKey,
        activePrefixes: ["/customer/leases"],
      },
      {
        to: "/customer/saved",
        label: "Following",
        icon: FiHeart,
        activePrefixes: ["/customer/saved", "/customer/following"],
      },
      {
        to: "/customer/shared-with-me",
        label: "Shared with Me",
        icon: FiFolder,
        activePrefixes: ["/customer/shared-with-me"],
      },
    ],
  },
  {
    id: "people",
    title: "People",
    items: [
      {
        to: "/customer/friends",
        label: "Friends",
        icon: FiUsers,
        activePrefixes: ["/customer/friends"],
      },
      {
        to: "/customer/agents",
        label: "Agents",
        icon: FiUser,
        activePrefixes: ["/customer/agents"],
      },
    ],
  },
].map((section) => ({
  ...section,
  items: section.items.map(createItem),
}));

export const getCustomerPageTitle = (pathname) => {
  const allItems = customerSidebarSections.flatMap((s) => s.items);
  const found = allItems.find((item) =>
    item.activePrefixes.some(
      (prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)
    )
  );
  return found?.label ?? "Customer Dashboard";
};

const customerNavigation = {
  sections: customerSidebarSections,
};

export default customerNavigation;
